export const roomsKeys = {
  all: ["rooms"] as const,
  lists: () => [...roomsKeys.all, "list"] as const,
  list: (stagingId: number | null) => [...roomsKeys.lists(), stagingId] as const,
};

export const roomKeys = {
  all: ["room"] as const,
  details: () => [...roomKeys.all, "detail"] as const,
  detail: (roomId: number | null | undefined) => [...roomKeys.details(), roomId] as const,
};
